import React, { useContext, useEffect, useRef, useState } from "react";
import HeadBar from "../headBar/HeadBar";
import Footer from "../footer/Footer";
import styles from "./NewLogin.module.css";
import Button from "../../material/button/Button";
import Input from "../../material/input/Input";
import Select from "../../material/select/Select";
import PasswordInput from "../../material/passwordInput/PasswordInput";
import LoadingWithClose from "../../material/loadingWithClose/LoadingWithClose";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { QRCodeSVG } from "qrcode.react";
import * as oneIdApi from "../../../service/oneIdApi";
import * as userApi from "../../../service/userApi";
import * as pubilcApi from "../../../service/publicApi";
import moment from "moment";
import AdviceModal from "../adviceModal/AdviceModal";
import { CurrentUserContext } from "../../../App";
import { RedirectCode400 } from "../../RedirectCode400";
import { environment } from "../../../config.env";
import Breadcrumb from "../breacrumb/breadcrumb";
import { SvgIcon } from "@mui/material";
const ENDPOINT_MOHPROMT = environment.mohpromt_url || "";
const ENDPOINT_MOHPROMT_CLIENT_ID = environment.mohpromt_client_id || "";
const ENDPOINT_HEALTH_ID = environment.health_id_url || "";
const ENDPOINT_HEALTH_ID_CLIENT_ID = environment.health_id_client_id || "";
const ENDPOINT_PROVIDER_ID = environment.provider_id_url || "";
const ENDPOINT_PROVIDER_ID_CLIENT_ID = environment.provider_id_client_id || "";
const REDIRECT_DOMAIN = environment.redirect_domain || "";
// Callback bases for the Health ID / Provider ID OAuth redirect_uri. Default to
// the app's own domain (where /loginHealthID and /loginProviderID are served).
const HEALTH_ID_REDIRECT = environment.health_id_redirect || REDIRECT_DOMAIN;
const PROVIDER_ID_REDIRECT = environment.provider_id_redirect || REDIRECT_DOMAIN;

function Login() {
  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const [showAdvice, setShowAdvice] = useState(false);
  const [role, setRole] = useState("PATIENT");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [thaiID, setThaiID] = useState("");
  const nav = useNavigate();

  const checkExpireToken = (expire) => {
    //console.log("expire");
    //console.log(expire);
    let diff = moment().diff(expire, "seconds");
    //console.log(diff);
    if (diff >= 0) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (userRole === null) {
    } else {
      const tokenExpireAuth = localStorage.getItem("expire_login_user");
      if (checkExpireToken(tokenExpireAuth)) {
        nav(RedirectCode400());
        if (!tokenExpireAuth) {
        } else {
          window.location.reload();
        }
        return;
      }
    }
  }, [userRole]);

  const loginUserNameButton = async () => {
    if (!role) {
      setIsMessage({
        type: "warning",
        data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
      });
      return;
    } else if (!thaiID) {
      setIsMessage({
        type: "warning",
        data: "กรุณากกรอกเลขบัตรประจำตัวประชาชน",
      });
      return;
    } else if (!password) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสผ่าน" });
      return;
    }

    const cleanThaiID = thaiID.replace(/-/g, ""); // เอาขีดออกก่อนตรวจสอบ
    if (!validateThaiID(cleanThaiID)) {
      setIsMessage({
        type: "warning",
        data: "กรุณากกรอกเลขบัตรประจำตัวประชาชนให้ถูกต้อง",
      });
      return;
    }

    setLoading(true);
    let res = await userApi.newLogin(cleanThaiID, password, role);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        logedIn(res["data"]);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const logedIn = (data) => {
    localStorage.setItem(
      "pg_access_token",
      data["user_data"]["auth"]["access_token"],
    );
    localStorage.setItem(
      "expire_login_user",
      data["user_data"]["auth"]["access_token_expire"],
    );
    localStorage.setItem("user", JSON.stringify(data["user_data"]));
    setUserRole(data["user_data"]);
    if (data.user_data.auth.role[0] === "MEDICAL_PERSONNEL") {
      nav("/search-for-patient-information");
    } else if (data.user_data.auth.role[0] === "HOSPITAL_PERSONNEL") {
      nav("/");
    } else if (data.user_data.auth.role[0] === "LABORATORY_ADMIN") {
      nav("/inputdata");
    } else if (data.user_data.auth.role[0] === "LABORATORY_PERSONNEL") {
      nav("/");
    } else if (data.user_data.auth.role[0] === "PATIENT") {
      nav("/");
    } else if (data.user_data.auth.role[0] === "ADMIN") {
      nav("/admin");
    } else if (data.user_data.auth.role[0] === "EXECUTIVE") {
      nav("/manager/aggregateResult");
    } else if (data.user_data.auth.role[0] === "HOSPITAL") {
      nav("/hospital/setting");
    } else {
      console.log("ยังไม่ได้ทำfunction check role user");
    }
  };

  const suggestionButton = () => {
    setShowAdvice(true);
  };

  const forgetPasswordButton = () => {
    // nav("/resetPassword");
    nav("/forgotPassword");
  };

  const clickGetOauthUrl = async () => {
    if (!role) {
      setIsMessage({
        type: "warning",
        data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
      });
      return;
    }

    setLoading(true);
    let res = await pubilcApi.getOauthUrlThaiID(role);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        console.log("-----");

        console.log(res["data"]["auth_url"]);
        console.log("-----");
        setTimeout(() => {
          window.open(res["data"]["auth_url"], "_blank");
        }, 0);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const clickGetLoginMohPromt = async () => {
    if (!role) {
      setIsMessage({
        type: "warning",
        data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
      });
      return;
    }

    window.open(
      `${ENDPOINT_MOHPROMT}/oauth/redirect?client_id=${ENDPOINT_MOHPROMT_CLIENT_ID}&redirect_uri=${REDIRECT_DOMAIN}/loginMohPromt/${role}&response_type=code`,
      "_system",
    );
  };

  // Health ID — citizen identity, always logs in as PATIENT.
  const clickGetLoginHealthID = async () => {
    if (!ENDPOINT_HEALTH_ID || !ENDPOINT_HEALTH_ID_CLIENT_ID) {
      setIsMessage({
        type: "warning",
        data: "ยังไม่ได้ตั้งค่าการเข้าใช้งานด้วย Health ID",
      });
      return;
    }

    window.open(
      `${ENDPOINT_HEALTH_ID}/oauth/redirect?client_id=${ENDPOINT_HEALTH_ID_CLIENT_ID}&redirect_uri=${HEALTH_ID_REDIRECT}/loginHealthID&response_type=code`,
      "_system",
    );
  };

  // Provider ID — healthcare-provider identity, logs in personnel by role.
  const clickGetLoginProviderID = async () => {
    if (!role) {
      setIsMessage({
        type: "warning",
        data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
      });
      return;
    }
    // if (role === "PATIENT") {
    //   setIsMessage({
    //     type: "warning",
    //     data: "บทบาทประชาชนกรุณาเข้าใช้งานด้วย Health ID",
    //   });
    //   return;
    // }
    if (!ENDPOINT_PROVIDER_ID || !ENDPOINT_PROVIDER_ID_CLIENT_ID) {
      setIsMessage({
        type: "warning",
        data: "ยังไม่ได้ตั้งค่าการเข้าใช้งานด้วย Provider ID",
      });
      return;
    }

    sessionStorage.setItem("provider_id_user_type", role);
    window.open(
      `${ENDPOINT_PROVIDER_ID}/v1/oauth2/authorize?client_id=${ENDPOINT_PROVIDER_ID_CLIENT_ID}&redirect_uri=${PROVIDER_ID_REDIRECT}/loginProviderID&response_type=code`,
      "_system",
    );
  };

  const onChangeRoleHandle = (e) => {
    setRole(e.target.value);
  };

  const handleThaiIdChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // กรองเฉพาะตัวเลข
    setThaiID(formatThaiID(value)); // จัดรูปแบบ
  };

  const validateThaiID = (id) => {
    const cleanID = id.replace(/-/g, ""); // เอาขีด (-) ออกก่อนตรวจสอบ
    if (!/^\d{13}$/.test(cleanID)) return false;

    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(cleanID[i]) * (13 - i);
    }

    const checkDigit = (11 - (sum % 11)) % 10;
    return checkDigit === parseInt(cleanID[12]);
  };

  const formatThaiID = (id) => {
    const cleanID = id.replace(/[^0-9]/g, ""); // กรองเฉพาะตัวเลข
    const parts = [];
    if (cleanID.length > 0) parts.push(cleanID.substring(0, 1)); // 1 หลักแรก
    if (cleanID.length > 1) parts.push(cleanID.substring(1, 5)); // 4 หลักถัดไป
    if (cleanID.length > 5) parts.push(cleanID.substring(5, 10)); // 5 หลักถัดไป
    if (cleanID.length > 10) parts.push(cleanID.substring(10, 12)); // 2 หลักถัดไป
    if (cleanID.length > 12) parts.push(cleanID.substring(12, 13)); // 1 หลักสุดท้าย
    return parts.join("-");
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "เข้าสู่ระบบ", url: "/login" },
  ];

  return (
    <>
      <main className="global-page">
        <AdviceModal
          show={showAdvice}
          onClose={() => {
            setShowAdvice(false);
          }}
        />
        <HashLoader
          loading={loading}
          style={{ display: "flex", justifyContent: "center" }}
          color="#FF9768"
        />
        <Breadcrumb pathItems={pathItems} />
        <div className="w-[min(1200px,95%)] md:mt-0 lg:mt-[55px] mt-[110px] mx-auto">
          <div className={styles.content}>
            <div className={styles.rightContent}>
              <div className={styles.title} style={{ marginTop: 20 }}>
                เข้าสู่ระบบ
              </div>
              <div>
                <div className="flex flex-wrap justify-between items-center">
                  <span className={styles.keyInput}>
                    เลือกประเภทของผู้เข้าใช้งาน
                  </span>

                  <span
                    className="ms-auto"
                    style={{ color: "orange", fontSize: "0.725rem" }}
                  >
                    กรุณาเลือกประเภทของผู้ใช้งานของท่าน*
                  </span>
                </div>
                <label htmlFor={`user_type`} className="sr-only">
                  เลือกประเภทของผู้เข้าใช้งาน
                </label>
                <select
                  onChange={onChangeRoleHandle}
                  className={styles.selectInput}
                  id="user_type"
                >
                  {/* <option>เลือกประเภทของผู้เข้าใช้งาน</option> */}
                  <option value={"PATIENT"}>ประชาชนทั่วไป</option>
                  <option value={"MEDICAL_PERSONNEL"}>แพทย์/เภสัช</option>
                  <option value={"LABORATORY_ADMIN"}>
                    ผู้ดูแลห้องปฏิบัติการ
                  </option>
                  <option value={"LABORATORY_PERSONNEL"}>
                    ผู้ปฏิบัติการในห้องปฏิบัติการ
                  </option>
                  <option value={"HOSPITAL_PERSONNEL"}>
                    เจ้าหน้าที่โรงพยาบาล
                  </option>
                  <option value={"EXECUTIVE"}>ผู้บริหาร</option>
                  <option value={"HOSPITAL"}>โรงพยาบาล</option>
                  <option value={"ADMIN"}>ผู้ดูแลระบบ/แอดมิน</option>
                </select>
              </div>
            </div>
          </div>
          <div className="flex justify-center w-full">
            <hr
              className={styles.lineunder}
              style={{
                margin: "3rem 0 2rem 0",
                width: "80%",
                borderColor: "#a9a7b1",
                opacity: 0.5,
              }}
            />
          </div>

          <div className={styles.optionContent}>
            <div className={styles.otherLogin}>
              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #01169B",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  clickGetOauthUrl();
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/thaiId.svg").default}
                  alt={`รูปประกอบThaiD`}
                ></img>
                <span className={styles.text} style={{ color: "#00169B" }}>
                  เข้าใช้งานด้วย ThaiD
                </span>
              </button>

              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #046839",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  clickGetLoginMohPromt();
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/mooprom.svg").default}
                  alt={`รูปประกอบหมอพร้อม`}
                ></img>
                <span className={styles.text} style={{ color: "#046839" }}>
                  เข้าใช้งานด้วยหมอพร้อม
                </span>
              </button>
            </div>
          </div>

          {/* New row: Health ID + Provider ID (same style as ThaiD) */}
          <div className={styles.optionContent} style={{ marginTop: "1rem" }}>
            <div className={styles.otherLogin}>
              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #0E7490",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  if (role !== "PATIENT") {
                    setIsMessage({
                      type: "warning",
                      data: "สามารถเข้าใช้งานด้วย Health ID ได้เฉพาะผู้ใช้งานประเภทประชาชนทั่วไปเท่านั้น",
                    });
                    return;
                  }
                  clickGetLoginHealthID();
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/DID.svg").default}
                  alt={`รูปประกอบHealthID`}
                ></img>
                <span className={styles.text} style={{ color: "#0E7490" }}>
                  เข้าใช้งานด้วย Health ID
                </span>
              </button>

              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #7A1FA2",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  if (role === "PATIENT") {
                    setIsMessage({
                      type: "warning",
                      data: "สามารถเข้าใช้งานด้วย Provider ID ได้เฉพาะผู้ใช้งานประเภทเจ้าหน้าที่โรงพยาบาล แพทย์ เภสัชกร เจ้าหน้าที่ห้องปฏิบัติการ และผู้ดูแลระบบ/แอดมินเท่านั้น",
                    });
                    return;
                  }
                  clickGetLoginProviderID();
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/MEDICALicon.svg").default}
                  alt={`รูปประกอบProviderID`}
                ></img>
                <span className={styles.text} style={{ color: "#7A1FA2" }}>
                  เข้าใช้งานด้วย Provider ID
                </span>
              </button>
            </div>
          </div>

          <div className={styles.orContent}>
            <div className={styles.otherOr}>
              <div className={styles.line}></div>
              <span>หรือ</span>
              <div className={styles.line}></div>
            </div>
          </div>

          <div className={styles.content}>
            <div className={styles.rightContent}>
              <div>
                <div className={styles.keyInput}>เลขบัตรประจำตัวประชาชน</div>
                <label htmlFor={`pid`} className="sr-only">
                  เลือกประเภทของผู้เข้าใช้งาน
                </label>
                <input
                  id="pid"
                  type="text"
                  value={thaiID}
                  onChange={handleThaiIdChange}
                  placeholder="กรอกเลขบัตรประจำตัวประชาชน 13 หลัก"
                  maxLength="17" // รวมขีดแล้วจะเป็น 17 ตัว
                  className={styles.input}
                  autoComplete="off"
                  //style={{ padding: '10px', fontSize: '16px' }}
                />
              </div>
              <div>
                {/* <div className={styles.keyInput}>รหัสผ่าน</div> */}
                <PasswordInput
                  disabledLabel={false}
                  onEnter={loginUserNameButton}
                  placeholder="รหัสผ่าน"
                  value={password}
                  setValue={setPassword}
                  id="user-password"
                ></PasswordInput>
                <div className={styles.forgetPasswordContainer}>
                  <div
                    className={styles.forgetPasswordButton}
                    onClick={() => {
                      forgetPasswordButton();
                    }}
                  >
                    ลืมรหัสผ่าน
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    disabled={loading}
                    onClick={loginUserNameButton}
                    style={{ height: "50px", borderRadius: "4px" }}
                  >
                    เข้าสู่ระบบ
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className={styles.suggestionContainer}>
          <img
            src={require("../../../asset/icon/suggestion-icon.svg").default}
          ></img>
          <div
            className={styles.text}
            onClick={() => {
              suggestionButton();
            }}
          >
            แนะนำการสมัครใช้งานและการเข้าสู่ระบบ
          </div>
        </div> */}
      </main>
    </>
  );
}

export default Login;
